// src/pages/ForgotPassword.jsx - Forgot Password Page
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await api.post('/auth/forgot-password', { email });
      setSubmitted(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to send reset email');
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div style={{ 
        minHeight: '100vh', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #6B3FA0 0%, #4A2B70 100%)',
        padding: '20px'
      }}>
        <div style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          boxShadow: '0 20px 60px rgba(74, 43, 112, 0.3)',
          width: '100%',
          maxWidth: '450px',
          overflow: 'hidden'
        }}>
          {/* Header Section */}
          <div style={{
            background: 'linear-gradient(135deg, #F3EEFA 0%, #ffffff 100%)',
            padding: '40px',
            textAlign: 'center',
            borderBottom: '3px solid #6B3FA0'
          }}>
            <img 
              src="/images/342px_x_216px-01.png" 
              alt="Kyber Security" 
              style={{ 
                height: '60px', 
                width: 'auto',
                marginBottom: '20px'
              }}
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
            <h1 style={{ 
              margin: 0, 
              marginBottom: '8px',
              fontSize: '28px',
              color: '#4A2B70',
              fontWeight: '700'
            }}>
              Check Your Email
            </h1>
          </div>

          {/* Success Message */}
          <div style={{ padding: '40px' }}>
            <div style={{
              textAlign: 'center',
              marginBottom: '25px'
            }}>
              <div style={{
                width: '80px',
                height: '80px',
                margin: '0 auto 20px',
                background: 'linear-gradient(135deg, #27AE60 0%, #1E8449 100%)',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                  <polyline points="22 4 12 14.01 9 11.01"></polyline>
                </svg>
              </div>
              <h2 style={{
                margin: 0,
                marginBottom: '15px',
                fontSize: '22px',
                color: '#4A2B70',
                fontWeight: '600'
              }}>
                Email Sent!
              </h2>
            </div>

            <p style={{ 
              textAlign: 'center', 
              color: '#666',
              lineHeight: '1.6',
              marginBottom: '25px'
            }}>
              If an account exists for <strong>{email}</strong>, you will receive a password reset link shortly.
            </p>

            <p style={{ 
              textAlign: 'center', 
              color: '#666',
              fontSize: '14px',
              marginBottom: '25px'
            }}>
              The link will expire in <strong>1 hour</strong>.
            </p>

            <div style={{
              backgroundColor: '#FFF3CD',
              border: '1px solid #FFC107',
              borderRadius: '8px',
              padding: '15px',
              marginBottom: '25px'
            }}>
              <p style={{
                margin: 0,
                fontSize: '13px',
                color: '#856404',
                lineHeight: '1.5'
              }}>
                <strong>💡 Tip:</strong> Check your spam folder if you don't see the email within a few minutes.
              </p>
            </div>

            <Link to="/login">
              <button
                style={{
                  width: '100%',
                  padding: '14px',
                  backgroundColor: '#6B3FA0',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '16px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  boxShadow: '0 4px 12px rgba(107, 63, 160, 0.3)'
                }}
                onMouseOver={(e) => {
                  e.target.style.backgroundColor = '#5A2F8A';
                  e.target.style.transform = 'translateY(-2px)';
                  e.target.style.boxShadow = '0 6px 16px rgba(107, 63, 160, 0.4)';
                }}
                onMouseOut={(e) => {
                  e.target.style.backgroundColor = '#6B3FA0';
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = '0 4px 12px rgba(107, 63, 160, 0.3)';
                }}
              >
                Back to Sign In
              </button>
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={{ 
      minHeight: '100vh', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #6B3FA0 0%, #4A2B70 100%)',
      padding: '20px'
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '12px',
        boxShadow: '0 20px 60px rgba(74, 43, 112, 0.3)',
        width: '100%',
        maxWidth: '450px',
        overflow: 'hidden'
      }}>
        {/* Header Section */}
        <div style={{
          background: 'linear-gradient(135deg, #F3EEFA 0%, #ffffff 100%)',
          padding: '40px',
          textAlign: 'center',
          borderBottom: '3px solid #6B3FA0'
        }}>
          <img 
            src="/images/342px_x_216px-01.png" 
            alt="Kyber Security" 
            style={{ 
              height: '60px', 
              width: 'auto',
              marginBottom: '20px'
            }}
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
          <h1 style={{ 
            margin: 0, 
            marginBottom: '8px',
            fontSize: '28px',
            color: '#4A2B70',
            fontWeight: '700'
          }}>
            Forgot Password
          </h1>
          <p style={{ 
            margin: 0, 
            fontSize: '15px', 
            color: '#7E4DB3',
            fontWeight: '400'
          }}>
            We'll send you a reset link
          </p>
        </div>

        {/* Form Section */}
        <div style={{ padding: '40px' }}>
          <p style={{
            textAlign: 'center',
            color: '#666',
            marginBottom: '25px',
            lineHeight: '1.6'
          }}>
            Enter your email address and we'll send you a link to reset your password.
          </p>

          {error && (
            <div style={{
              padding: '15px',
              marginBottom: '25px',
              backgroundColor: '#FEE',
              border: '1px solid #FCC',
              borderLeft: '4px solid #E74C3C',
              borderRadius: '6px',
              color: '#C00',
              fontSize: '14px'
            }}>
              <strong>Error:</strong> {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: '25px' }}>
              <label style={{ 
                display: 'block', 
                marginBottom: '8px', 
                fontWeight: '600',
                color: '#4A2B70',
                fontSize: '14px'
              }}>
                Email Address
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="Enter your email"
                style={{
                  width: '100%',
                  padding: '12px 15px',
                  border: '2px solid #E5D5F5',
                  borderRadius: '8px',
                  fontSize: '15px',
                  transition: 'all 0.2s ease',
                  fontFamily: 'inherit'
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = '#6B3FA0';
                  e.target.style.boxShadow = '0 0 0 3px rgba(107, 63, 160, 0.1)';
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = '#E5D5F5';
                  e.target.style.boxShadow = 'none';
                }}
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              style={{
                width: '100%',
                padding: '14px',
                backgroundColor: loading ? '#9B7BB8' : '#6B3FA0',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                fontSize: '16px',
                fontWeight: '600',
                cursor: loading ? 'not-allowed' : 'pointer',
                transition: 'all 0.2s ease',
                boxShadow: '0 4px 12px rgba(107, 63, 160, 0.3)',
                marginBottom: '20px'
              }}
              onMouseOver={(e) => {
                if (!loading) {
                  e.target.style.backgroundColor = '#5A2F8A';
                  e.target.style.transform = 'translateY(-2px)';
                  e.target.style.boxShadow = '0 6px 16px rgba(107, 63, 160, 0.4)';
                }
              }}
              onMouseOut={(e) => {
                if (!loading) {
                  e.target.style.backgroundColor = '#6B3FA0';
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = '0 4px 12px rgba(107, 63, 160, 0.3)';
                }
              }}
            >
              {loading ? (
                <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
                  <span style={{
                    display: 'inline-block',
                    width: '16px',
                    height: '16px',
                    border: '2px solid white',
                    borderTopColor: 'transparent',
                    borderRadius: '50%',
                    animation: 'spin 0.6s linear infinite'
                  }}></span>
                  Sending...
                </span>
              ) : (
                'Send Reset Link'
              )}
            </button>

            <div style={{ textAlign: 'center' }}>
              <Link 
                to="/login" 
                style={{
                  color: '#6B3FA0',
                  textDecoration: 'none',
                  fontSize: '14px',
                  fontWeight: '600'
                }}
              >
                ← Back to Sign In
              </Link>
            </div>
          </form>
        </div>

        {/* Footer Section */}
        <div style={{
          padding: '20px 40px',
          backgroundColor: '#F3EEFA',
          borderTop: '1px solid #E5D5F5',
          textAlign: 'center'
        }}>
          <p style={{ 
            margin: 0, 
            fontSize: '13px', 
            color: '#7E4DB3',
            lineHeight: '1.5'
          }}>
            Need help? Contact <a href="mailto:support@kybersecure.com" style={{ color: '#6B3FA0', fontWeight: '600' }}>support@kybersecure.com</a>
          </p>
        </div>
      </div>

      <style>
        {`
          @keyframes spin {
            to { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
};

export default ForgotPassword;
